import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Layout from './components/Layout';
import OrderListPage from './pages/OrderList/OrderList';
import OrderNewPage from './pages/OrderNew/OrderNew';
import OrderDetailPage from './pages/OrderDetail/OrderDetail';
import OrderEditPage from './pages/OrderEdit/OrderEdit';
import NotFound from './pages/NotFound/NotFound';

const RoutesComponent = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<OrderListPage />} />
        <Route path="orders/new" element={<OrderNewPage />} />
        <Route path="orders/:id" element={<OrderDetailPage />} />
        <Route path="orders/:id/edit" element={<OrderEditPage />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default RoutesComponent;
